import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { createMask } from '@ngneat/input-mask';
import { ComplianceSettingForm } from 'src/app/classes/form-groups/compliance-setting-form';
import { Company } from 'src/app/classes/models';
import { ComplianceSettingLiabilityType } from 'src/app/interfaces/compliance-setting-liability-types';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-compliance-auto-liability',
  templateUrl: './compliance-auto-liability.component.html',
  styleUrls: ['./compliance-auto-liability.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ComplianceAutoLiabilityComponent implements OnInit {
  constructor(private UtilityService: UtilityService) {}

  @Input() complianceSettingForms?: ComplianceSettingForm[];
  @Input() company?: Company;
  @Input() amBestValueMap?: Map<string, string | number | null>;
  @Input() amBestFinancialValueMap?: Map<
    string,
    { value: string | null; hint: string }
  >;

  @Output() updateRequiredFields =
    new EventEmitter<ComplianceSettingLiabilityType>();

  checkBoxFields?: Map<
    string,
    { controlName: string; show: boolean; labelText?: 'Required?' | 'Allowed?' }
  >;

  collapseAutoLiabilities: boolean = true;

  currencyMask = createMask({
    alias: 'numeric',
    groupSeparator: ',',
    placeholder: '',
    rightAlign: false
  });

  applyCurrencyFormat(FormControl: FormControl, value: any) {
    FormControl.patchValue(
      value === null ? null : parseInt(value.replace(/[^\d]/g, ''), 10),
      { emitViewToModelChange: false }
    );
  }

  keyValuePairDefaultOrder(
    a: KeyValue<any, any>,
    b: KeyValue<any, any>
  ): number {
    return 0;
  }

  onAutoLiabilityIsRequiredChange() {
    this.updateRequiredFields.emit('autoLiability');
  }

  ngOnInit(): void {
    this.updateRequiredFields.emit('autoLiability');

    this.checkBoxFields = new Map([
      ['Additional Insured', { controlName: 'autoIsNamed', show: true }],
      ['Waiver of Subrogation', { controlName: 'autoIsAgency', show: true }],
      [
        'Valid Description of Operations',
        { controlName: 'autoDescOps', show: true }
      ],
      [
        'Non-Commercial Auto Policies',
        {
          controlName: 'allowNonCommercialPolicy',
          show: true,
          labelText: 'Allowed?'
        }
      ],
      [
        'Hired & Non-Owned Auto Coverage',
        { controlName: 'autoLiability_hasNonOwnedAuto', show: true }
      ],
      [
        'Pass Full Policy Review',
        { controlName: 'autoLiability_hasFullPolicyDoc', show: true }
      ],
      [
        'Has Required Forms',
        { controlName: 'autoLiability_hasRequiredForms', show: true }
      ],
      [
        'COI Name/Legal Name Mismatch',
        { controlName: 'autoLiability_legalNameMismatch', show: true }
      ]
    ]);
  }
}
